import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "motion/react";
import { Menu, X } from "lucide-react";
import { siteData } from "../../data/mock";
import { Button } from "../ui/button";

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToSection = (href) => {
    setMobileOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <motion.header
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ type: "spring", damping: 80, stiffness: 400 }}
      className={`fixed top-0 left-0 right-0 z-50 transition-colors transition-shadow duration-300 ${
        scrolled
          ? "bg-white/90 backdrop-blur-md shadow-sm"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-[1200px] mx-auto px-6 md:px-8">
        <div className="flex items-center justify-between h-[72px]">
          {/* Logo */}
          <a href="#" className="flex items-center gap-2 no-underline">
            <div className="w-8 h-8 rounded-lg bg-[#008055] flex items-center justify-center">
              <span className="text-white font-semibold text-sm">P2</span>
            </div>
            <span className="text-[#0A0A0A] font-semibold text-lg tracking-tight">
              {siteData.brand.name}
            </span>
          </a>

          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center gap-8">
            {siteData.nav.map((item) => (
              <button
                key={item.label}
                onClick={() => scrollToSection(item.href)}
                className="text-[#3C3B3D] hover:text-[#008055] text-[15px] font-normal bg-transparent border-none cursor-pointer transition-colors duration-200"
              >
                {item.label}
              </button>
            ))}
          </nav>

          {/* Desktop CTA */}
          <div className="hidden md:flex items-center gap-3">
            <Button
              variant="outline"
              className="rounded-full border-[#CBC9CF] text-[#3C3B3D] hover:border-[#008055] hover:text-[#008055] px-5 h-10 text-sm"
              onClick={() => scrollToSection("#faq")}
            >
              Learn More
            </Button>
            <button
              onClick={() => scrollToSection("#final-cta")}
              className="bg-[#008055] hover:bg-[#0A6647] text-white border-none rounded-full px-5 h-10 text-sm font-normal cursor-pointer transition-colors duration-200"
            >
              Book a Demo
            </button>
          </div>

          {/* Mobile Menu Toggle */}
          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden bg-transparent border-none cursor-pointer p-1 text-[#0A0A0A]"
          >
            {mobileOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence>
        {mobileOpen && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            className="md:hidden bg-white border-t border-[#E6E4EB] overflow-hidden"
          >
            <div className="px-6 py-4 flex flex-col gap-3">
              {siteData.nav.map((item) => (
                <button
                  key={item.label}
                  onClick={() => scrollToSection(item.href)}
                  className="text-left text-[#3C3B3D] hover:text-[#008055] text-base font-normal bg-transparent border-none cursor-pointer py-2 transition-colors duration-200"
                >
                  {item.label}
                </button>
              ))}
              <button
                onClick={() => scrollToSection("#final-cta")}
                className="mt-2 bg-[#008055] text-white border-none rounded-full px-5 h-11 text-sm font-normal cursor-pointer w-full transition-colors duration-200"
              >
                Book a Demo
              </button>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.header>
  );
};
